// Whether to offer "also post to Vilogi" for a closed-session row — same eligibility as the list's Vilogi sync icon, minus sessions already syncing. 2026-10-20
export function canOfferVilogi(session, vilogiEnabled) {
  if (!vilogiEnabled || !session || session.is_voided) return false
  return ['not_scheduled', 'cancelled', 'error', 'reversed'].includes(session.vilogi_status)
}



// WEBPACK FOOTER //
// ./src/utils/vilogiPrompt.js